import React from 'react';
import { Tooltip, Typography } from '@mui/material';

function GridTypography(props) {
    const { title, tooltip } = props;

    function isInt(value) {
        return !isNaN(value) && (function (x) { return (x | 0) === x; })(parseFloat(value))
    }

    function formatCurrency(x) {
        x = x.toString();
        var pattern = /(-?\d+)(\d{3})/;
        while (pattern.test(x))
            x = x.replace(pattern, "$1,$2");
        return x;
    }

    return (
        <Tooltip title={isInt(tooltip) ? (tooltip < 0 ? `(${formatCurrency(-tooltip)})` : formatCurrency(tooltip)) : tooltip} placement="top" arrow>
            <Typography
                variant="body2"
                sx={{
                    fontSize: '9px',
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "3",
                    WebkitBoxOrient: "vertical",
                }}>
                {isInt(title) ? (title < 0 ? `(${formatCurrency(-title)})` : formatCurrency(title)) : title}
            </Typography>
        </Tooltip>
    );
}

export default GridTypography;
